import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { IconChat, IconCompare, IconKey } from './icons';
import { Reveal } from './Reveal';
import { Tilt3D } from './Tilt3D';
const STEPS = [{
  number: '01',
  icon: IconChat,
  title: 'how.1.title'
}, {
  number: '02',
  icon: IconCompare,
  title: 'how.2.title'
}, {
  number: '03',
  icon: IconKey,
  title: 'how.3.title'
}];
export function HowItWorks() {
  const {
    t
  } = useLanguage();
  return <section className="w-full bg-white" data-id="element-141" data-mp="lmcz668iljms">
      <div className="mx-auto w-full max-w-7xl px-4 py-16 sm:px-6 md:py-20" data-id="element-142" data-mp="qjwc92th7qd5">
        <Reveal data-id="element-143" data-mp="cry9d9qcyqpf">
          <h2 className="font-display text-2xl font-extrabold uppercase tracking-[0.16em] text-ink sm:text-3xl" data-id="element-144" data-mp="cshv71j4pz8q">
            {t('how.title')}
          </h2>
          <div aria-hidden="true" className="mt-3 h-[3px] w-12 bg-kred" data-id="element-145" data-mp="grgvu9xtv9ud" />
        </Reveal>
        <ol className="mt-10 grid grid-cols-1 gap-8 md:grid-cols-3" data-id="element-146" data-mp="14huoo2o8lcq0">
          {STEPS.map((step, index) => {
          const Icon = step.icon;
          return <li key={step.number} className="border-t border-camel/40 pt-5" data-id="element-147" data-mp="2rmpkmempwxvf" data-mpi={index}>
                <Reveal delay={index * 0.08} data-id="element-148" data-mp="2mn37s6asxjn5">
                  <Tilt3D max={6} lift={10} data-id="element-149" data-mp="2moecq9fzgxfu">
                    <div className="flex items-center gap-3" data-id="element-150" data-mp="31bze9yx7moln">
                    <span className="font-display text-2xl font-extrabold text-camelink" data-id="element-151" data-mp="31dk8fnfm45iz">
                      {step.number}
                    </span>
                    <Icon className="h-7 w-7 text-ink/45" data-id="element-152" data-mp="3abe2ssttgp3i" />
                  </div>
                    <h3 className="mt-4 font-display text-sm font-extrabold uppercase tracking-[0.16em] text-ink" data-id="element-153" data-mp="36b3lik0kqc9c">
                      {t(step.title)}
                    </h3>
                  </Tilt3D>
                </Reveal>
              </li>;
        })}
        </ol>
      </div>
    </section>;
}